export default "__VITE_ASSET__DFjV776s__"